type AccountHeaderProps = {
  firstName?: string
  email?: string
}

const AccountHeader = ({ firstName, email }: AccountHeaderProps) => {
  return (
    <div className="flex flex-col items-center">
      <div
        className="w-16 h-16 rounded-full flex items-center justify-center
             bg-white/15 ring-1 ring-white/20 text-white text-4xl leading-none"
      >
        {firstName?.[0] ?? '?'}
      </div>
      <p className="text-white font-bold text-center mt-4">{firstName}</p>
      <p className="text-white/90 text-sm mt-1">{email}</p>
    </div>
  )
}

export default AccountHeader
